import IPasswordFormProps from "../IPasswordFormProps";
import { Col, Row } from "react-grid-system";
import AddAttributeField from "../../../components/formFields/attributes/add/AddAttributeField";
import IAttribute from "../../../models/IAttribute";
import AttributesList from "../../../components/formFields/attributes/list/AttributesList";

export default function AttributesTab(props: IPasswordFormProps) {
    const handleAdd = (attribute: IAttribute) => {
        const newAttributes = props.data.attributes;
        newAttributes.push(attribute);

        props.onChange("attributes", newAttributes);
    }

    const handleRemove = (index: number) => {
        const newAttributes = props.data.attributes;
        newAttributes.splice(index, 1);

        props.onChange("attributes", newAttributes);
    }

    return (
        <Row>
            <Col>
                <AddAttributeField onAdd={handleAdd} />
                <AttributesList attributes={props.data.attributes} onRemove={handleRemove} />
            </Col>
        </Row>
    );
}